// extracted by mini-css-extract-plugin
module.exports = {"holdingImage":"holding-image_holdingImage__cL_Mv","icon":"holding-image_icon__1JJEV","holdingImageUnavailable":"holding-image_holdingImageUnavailable__fNJbU"};